"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PASTE = exports.CUT = exports.COPY = void 0;
exports.COPY = 'copy';
exports.CUT = 'cut';
exports.PASTE = 'paste';